import { render, staticRenderFns } from "./configlist.vue?vue&type=template&id=5a167d86&scoped=true&"
import script from "./configlist.vue?vue&type=script&lang=js&"
export * from "./configlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a167d86",
  null
  
)

export default component.exports